import { Children, ComponentType, isValidElement, ReactElement, ReactNode } from 'react';

export function iterateRecursivelyThroughChildren(
  children: ReactNode,
  callback: (child: ReactElement) => void,
) {
  Children.forEach(children, (child: ReactNode) => {
    if (isValidElement(child)) {
      if (child.props.children) {
        iterateRecursivelyThroughChildren(child.props.children, callback);
      }
      callback(child);
    }
  });
}

export function getFromChildren<T>(
  children: ReactNode,
  element: ComponentType,
  callback: (child: ReactElement) => T,
) {
  const result: T[] = [];

  iterateRecursivelyThroughChildren(children, (child) => {
    if (child.type === element) {
      result.push(callback(child));
    }
  });

  return result;
}
